import React from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import gql from "graphql-tag";

import { client } from "../index";

import { MIN_PASSWORD_LENGTH } from "../constants";

const CHANGE_PASSWORD = gql`
  mutation changePassword($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      isError
      message
    }
  }
`;

interface IChangePasswordProps {
  show: any;
  onHide: any;
}

export default class ChangePasswordModal extends React.Component<IChangePasswordProps> {
  state: {
    oldPassword: string;
    newPassword: string;
    newPasswordConfirmation: string;
    message?: string;
    isError?: boolean;
  };

  constructor(props: IChangePasswordProps) {
    super(props);

    this.state = {
      oldPassword: "",
      newPassword: "",
      newPasswordConfirmation: "",
      message: undefined,
      isError: undefined,
    };

    this.resetState = this.resetState.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.updateOldPassword = this.updateOldPassword.bind(this);
    this.updateNewPassword = this.updateNewPassword.bind(this);
    this.updateNewPasswordConfirmation = this.updateNewPasswordConfirmation.bind(
      this
    );
  }

  resetState() {
    this.setState({
      ...this.state,
      oldPassword: "",
      newPassword: "",
      newPasswordConfirmation: "",
      message: undefined,
      isError: undefined,
    });
  }

  updatePassword() {
    client
      .mutate({
        mutation: CHANGE_PASSWORD,
        variables: {
          oldPassword: this.state.oldPassword,
          newPassword: this.state.newPassword,
        },
      })
      .then((result: any) => {
        this.setState({
          ...this.state,
          isError: result.data.changePassword.isError,
          message: result.data.changePassword.message,
        });

        this.setState({
          oldPassword: "",
          newPassword: "",
          newPasswordConfirmation: "",
        });
      });
  }

  updateOldPassword(value: string) {
    this.setState({
      ...this.state,
      oldPassword: value,
      message: undefined,
      isError: undefined,
    });
  }

  updateNewPassword(value: string) {
    this.setState({ ...this.state, newPassword: value });
  }

  updateNewPasswordConfirmation(value: string) {
    this.setState({ ...this.state, newPasswordConfirmation: value });
  }

  validateForm() {
    return (
      this.state.oldPassword.length >= MIN_PASSWORD_LENGTH &&
      this.state.newPassword.length >= MIN_PASSWORD_LENGTH &&
      this.state.newPasswordConfirmation === this.state.newPassword
    );
  }

  render() {
    return (
      <Modal
        show={this.props.show}
        centered
        onHide={() => {
          this.resetState();
          this.props.onHide();
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Passwort ändern</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group as={Row}>
              <Form.Label column xs={3}>
                <strong>Bisheriges Passwort</strong>
              </Form.Label>
              <Col xs={9}>
                <Form.Control
                  placeholder="Bisheriges Passwort"
                  type="password"
                  value={this.state.oldPassword}
                  onChange={(ev: any) =>
                    this.updateOldPassword(ev.target.value)
                  }
                ></Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column xs={3}>
                <strong>Neues Passwort:</strong>
              </Form.Label>
              <Col xs={9}>
                <Form.Control
                  placeholder="Neues Passwort"
                  value={this.state.newPassword}
                  type="password"
                  onChange={(ev: any) =>
                    this.updateNewPassword(ev.target.value)
                  }
                ></Form.Control>
              </Col>
            </Form.Group>
            <Form.Group as={Row}>
              <Form.Label column xs={3}>
                <strong>Passwort bestätigen:</strong>
              </Form.Label>
              <Col xs={9}>
                <Form.Control
                  placeholder="Neues Passwort"
                  type="password"
                  value={this.state.newPasswordConfirmation}
                  onChange={(ev: any) =>
                    this.updateNewPasswordConfirmation(ev.target.value)
                  }
                ></Form.Control>
              </Col>
            </Form.Group>
          </Form>
          {this.state.newPassword.length > 0 &&
            this.state.newPassword.length < MIN_PASSWORD_LENGTH && (
              <p>
                Das neue Passwort ist zu kurz (mind. {MIN_PASSWORD_LENGTH}{" "}
                Zeichen)
              </p>
            )}
          {this.state.newPassword.length >= MIN_PASSWORD_LENGTH &&
            this.state.newPasswordConfirmation.length > 0 &&
            this.state.newPasswordConfirmation !== this.state.newPassword && (
              <p>Die Passwörter stimmen nicht überein.</p>
            )}
          {this.state.isError === true && (
            <p>Fehler beim Ändern des Passwortes: {this.state.message}</p>
          )}
          {this.state.isError === false && <p>{this.state.message}</p>}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              this.resetState();
              this.props.onHide();
            }}
          >
            {this.state.isError === false && "Schließen"}
            {this.state.isError !== false && "Abbrechen"}
          </Button>
          {this.state.isError !== false && (
            <Button
              variant="primary"
              disabled={!this.validateForm()}
              onClick={() => this.updatePassword()}
            >
              Passwort ändern
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}
